import React from "react";
import ReactDOM from "react-dom/client";
import { ClerkProvider } from "@clerk/clerk-react";
import "@/index.css";
import App from "@/App";

const clerkPubKey = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;

// Pre-render SDK-level signout. window.Clerk is set by Clerk's JS SDK if it has
// already initialised (e.g. from a previous page load). Fire-and-forget — we
// cannot await here, but even a partial signout before ClerkProvider mounts helps
// break the HttpOnly cookie loop on iPhone Safari.
if (
  window.location.search.includes('force_signout=1') ||
  window.location.pathname === '/login'
) {
  try { window.Clerk?.signOut(); } catch (_) {}
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ClerkProvider publishableKey={clerkPubKey}>
      <App />
    </ClerkProvider>
  </React.StrictMode>,
);
